<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="active-icon"
            @click="deviceBindDialog = true"
          >
            {{ $t("m.deviceManage.bindDevice.button.bindBtn") }}
          </el-button>
        </div>
      </div>
      <!--内容-->
      <div
        class="box-content"
        style="max-height:calc(100% - 160px);"
        v-if="active1 == 1"
      >
        <div
          @click="checkDevice(item)"
          :class="[
            item.bind.id == activeBindId
              ? 'box-item box-sb box-active'
              : 'box-item box-sb',
          ]"
          v-for="item in bindDeviceList"
          v-bind:key="item.device.id"
        >
          <div class="box-item-img">
            <img
              v-if="item.bind.id == activeBindId"
              src="../../assets/img/矩形4copy备份@2x.png"
            />
            <img v-else src="../../assets/img/矩形4copy备份@2x(1).png" />
            <div class="sb-name">{{ item.device.name }}</div>
            <div class="sb-type">{{ item.deviceType.name }}</div>
          </div>
        </div>
      </div>
      <div class="sb-footer">
        <el-divider style="margin:0 0 15px 0;"></el-divider>
        <div class="sb-footer-line" style="margin-bottom:15px;">
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.beanTemper") }}：</span
            ><span class="value">{{ mqttInfo.sdTemperature }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.inletAirTemperature") }}：</span
            ><span class="value">{{
              mqttInfo.outWindTemperature
            }}</span></el-button
          >
<!--          间隔两个取反-->
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.outWindTemper") }}：</span
            ><span class="value">{{
              mqttInfo.outSideTemperature
            }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.environmentTemper") }}：</span
            ><span class="value">{{
              mqttInfo.inWindTemperature
            }}</span></el-button
          >
        </div>
        <div class="sb-footer-line">
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.heating") }}</span
            ><span class="value">{{ mqttInfo.fire }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.airflow") }}：</span
            ><span class="value">{{ mqttInfo.wind }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.drum") }}：</span
            ><span class="value">{{ mqttInfo.speed }}</span></el-button
          >
          <el-button type="primary"
            ><span>{{ $t("m.deviceIndex.cooling") }}：</span
            ><span class="value">{{ mqttInfo.cold }}</span></el-button
          >
        </div>
      </div>
    </div>

    <div class="main-box border-1px-all">
      <section>
        <div class="flex flex-between">
          <div class="title-bc">{{ selectDevice.device.name }}</div>
          <el-button
            @click="deviceUnbind()"
            type="primary"
            icon="el-icon-delete"
            class="active-icon"
          >
            {{ $t("m.button.unbind") }}
          </el-button>
        </div>
        <div style="margin-top: 10px; color: #909399">
          <span class="gray-text"
            >{{ $t("m.deviceManage.bindDevice.systemSeriesNum") }}：</span
          >
          <span class="gray-text">{{ selectDevice.device.serino }}</span>
        </div>
        <!-- 2022-06-18 yuanzhiqi add 设备编号 -->
        <div style="margin-top: 10px; color: #909399">
          <span class="gray-text"
            >{{ $t("m.deviceManage.bindDevice.deviceSeriesNum") }}：</span
          >
          <span class="gray-text">{{ selectDevice.device.orino }}</span>
        </div>
      </section>
      <section style="margin-top: 20px">
        <div class="row-box" style="background-color: #2D2F35FF">
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.type") }}：</span
                >
                <span class="white-text">{{
                  selectDevice.deviceType.name
                }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.bindTime") }}：</span
                >
                <span class="white-text">{{
                  this.$moment(Number(selectDevice.bind.createtime)).format(
                    "YYYY-MM-DD"
                  )
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.bakeTime") }}：</span
                >
                <span class="white-text">
                  {{ timeFormatter(selectDevice.device.hbtime) }}
                </span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.runTimeLength") }}：</span
                >
                <span class="white-text">
                  {{ timeFormatter(selectDevice.device.runtime) }}
                </span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.deviceLocation") }}：</span
                >
                <span class="white-text">
                  <div type="" v-if="selectDevice.device.location == null">
                    {{ $t("m.deviceManage.bindDevice.notUpload") }}
                  </div>
                  <div type="" v-else>{{ selectDevice.device.location }}</div>
                </span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="flex flex-between">
                <span class="gray-text"
                  >{{ $t("m.deviceManage.bindDevice.deviceStatus") }}：</span
                >
                <span class="white-text">
                  <div v-if="selectDevice.device.status == null">
                    {{ $t("m.deviceManage.bindDevice.notUpload") }}
                  </div>
                  <div v-else>{{ selectDevice.device.status }}</div>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section>
        <div class="box-header flex flex-center" style="margin-top: 30px">
          <div class="box-header-left flex flex-center">
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 1 }"
              @click="active2 = 1"
              >{{ $t("m.deviceManage.bindDevice.curveList") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 2 }"
              @click="active2 = 2"
              >{{ $t("m.deviceManage.bindDevice.runLog") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 3 }"
              @click="active2 = 3"
              >{{ $t("m.deviceManage.bindDevice.roastLog") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 4 }"
              @click="active2 = 4"
              >{{ $t("m.deviceManage.bindDevice.maintenanceReminder") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 5 }"
              @click="active2 = 5"
              >{{ $t("m.deviceManage.bindDevice.maintenanceHistory") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active2 == 6 }"
              @click="active2 = 6"
              >{{ $t("m.deviceManage.bindDevice.alarmLog") }}</span
            >
          </div>
        </div>
      </section>
      <!--曲线列表-->
      <section v-show="active2 == 1">
        <el-table
          :data="deviceReportList"
          border
          style="width: 100%"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="report.name"
            :label="$t('m.deviceManage.bindDevice.name')"
          >
          </el-table-column>
          <el-table-column
            prop="reportVo.suitVo.suit.hbtime"
            :label="$t('m.deviceManage.bindDevice.duration')"
            width="60"
          >
          </el-table-column>
          <el-table-column
            prop="report.createtime"
            :label="$t('m.deviceManage.bindDevice.date')"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ $moment(Number(scope.row.report.createtime)).format("YYYY-MM-DD") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="report.level"
            :label="$t('m.deviceManage.bindDevice.star')"
            width="120"
          >
            <template slot-scope="scope">
              <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="scope.row.report.level"
                disabled
              ></el-rate>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('m.deviceManage.bindDevice.operation.name')"
            width="80"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                style="color: white"
                @click="reportDetailClick(scope.row)"
              >
                {{ $t("m.deviceManage.bindDevice.operation.detail") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-show="deviceReportPage.total > 0"
          background
          align="right"
          layout="prev, pager, next"
          style="margin-top: 10px"
          @current-change="deviceReportPageChange"
          @size-change="deviceReportPageSizeChange"
          :page-size="deviceReportPage.pageSize"
          :total="deviceReportPage.total"
        >
        </el-pagination>
      </section>
      <!--运行日志-->
      <section v-show="active2 == 2">
        <el-table
          :data="deviceTimeList"
          border
          style="width: 100%;"
          show-summary
          :summary-method="getSummaries"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="time"
            :label="
              $t('m.deviceManage.bindDevice.dialog.runTimeDialog.runTime')
            "
            width="150"
          >
            <template slot-scope="scope">
              {{ timeFormatter(scope.row.time) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createtime"
            :label="$t('m.deviceManage.bindDevice.dialog.runTimeDialog.date')"
            :formatter="dateFormat"
            align="center"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          align="right"
          layout="prev, pager, next"
          style="margin-top: 10px"
          @current-change="deviceTimePageChange"
          @size-change="deviceTimePageSizeChange"
          :page-size="deviceRuntimePage.pageSize"
          :total="deviceRuntimePage.total"
        >
        </el-pagination>
      </section>
      <!--烘焙日志-->
      <section v-show="active2 == 3">
        <el-table
          :data="deviceHbTimeList"
          show-summary
          :summary-method="getSummaries"
          border
          style="width: 100%;"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="time"
            :label="
              $t('m.deviceManage.bindDevice.dialog.runTimeDialog.timeLength')
            "
            width="150"
          >
            <template slot-scope="scope">
              {{ timeFormatter(scope.row.time) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createtime"
            :label="$t('m.deviceManage.bindDevice.dialog.runTimeDialog.date')"
            :formatter="dateFormat"
            align="center"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          align="right"
          layout="prev, pager, next"
          style="margin-top: 10px"
          @current-change="deviceHbTimePageChange"
          @size-change="deviceHbTimePageSizeChange"
          :page-size="deviceHbPage.pageSize"
          :total="deviceHbPage.total"
        >
        </el-pagination>
      </section>
      <!--维保提醒-->
      <section v-show="active2 == 4">
        <el-table
          :data="deviceRemainList"
          border
          style="width: 100%;"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="createtime"
            :formatter="dateFormat"
            :label="$t('m.deviceManage.bindDevice.date')"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="type"
            :label="$t('m.deviceManage.bindDevice.triggerCondition')"
          >
          </el-table-column>
          <el-table-column
            prop="content"
            :label="$t('m.deviceManage.bindDevice.content')"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('m.deviceManage.bindDevice.operation.name')"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                style="color: white"
                @click="deviceRemainEdit(scope.row)"
              >
                {{ $t("m.deviceManage.bindDevice.operation.edit") }}
              </el-button>
              <el-button
                type="text"
                size="small"
                style="color: white"
                @click="deviceRemainDelete(scope.row)"
              >
                {{ $t("m.deviceManage.bindDevice.operation.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex flex-between" style="margin-top: 10px;">
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="active-icon"
            align="left"
            @click="deviceRemainEdit(0)"
            >{{
              $t("m.deviceManage.bindDevice.addMaintenanceReminder")
            }}</el-button
          >
          <el-pagination
            background
            align="right"
            layout="prev, pager, next"
            @current-change="deviceRemainPageChange"
            @size-change="deviceRemainPageSizeChange"
            :page-size="deviceRemainPage.pageSize"
            :total="deviceRemainPage.total"
          >
          </el-pagination>
        </div>
      </section>
      <!--维保历史-->
      <section v-show="active2 == 5">
        <el-table
          :data="deviceMaintainList"
          border
          style="width: 100%;"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="createtime"
            :formatter="dateFormat"
            :label="
              $t(
                'm.deviceManage.bindDevice.dialog.maintainDialog.tabMaintainLog.date'
              )
            "
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="content"
            :label="
              $t(
                'm.deviceManage.bindDevice.dialog.maintainDialog.tabMaintainLog.solution'
              )
            "
            align="center"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('m.deviceManage.bindDevice.operation.name')"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                style="color: white"
                @click="deviceMaintainEdit(scope.row)"
              >
                {{ $t("m.deviceManage.bindDevice.operation.edit") }}
              </el-button>
              <el-button
                type="text"
                size="small"
                style="color: white"
                @click="deviceMaintainDelete(scope.row)"
              >
                {{ $t("m.deviceManage.bindDevice.operation.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex flex-between" style="margin-top: 10px;">
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="active-icon"
            align="left"
            @click="deviceMaintainEdit(0)"
            >{{
              $t("m.deviceManage.bindDevice.addMaintenanceHistory")
            }}</el-button
          >
          <el-pagination
            background
            align="right"
            layout="prev, pager, next"
            @current-change="deviceMaintainPageChange"
            @size-change="deviceMaintainPageSizeChange"
            :page-size="deviceMaintainPage.pageSize"
            :total="deviceMaintainPage.total"
          >
          </el-pagination>
        </div>
      </section>
      <!--报警日志-->
      <section v-show="active2 == 6">
        <el-table
          :data="deviceWarnList"
          border
          style="width: 100%;"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            prop="id"
            :label="$t('m.deviceManage.bindDevice.no')"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="createtime"
            :formatter="dateFormat1"
            :label="$t('m.deviceManage.bindDevice.date')"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="content"
            :label="$t('m.deviceManage.bindDevice.tableType')"
            align="center"
          >
          </el-table-column>
        </el-table>
        <div class="flex flex-between" style="margin-top: 10px;">
          <el-pagination
            background
            align="right"
            layout="prev, pager, next"
            @current-change="deviceWarnPageChange"
            @size-change="deviceWarnPageSizeChange"
            :page-size="deviceWarnPage.pageSize"
            :total="deviceWarnPage.total"
          >
          </el-pagination>
        </div>
      </section>
    </div>
    <!--------绑定弹框---------->
    <el-dialog
      :title="$t('m.deviceManage.bindDevice.dialog.bindDialog.title')"
      :visible.sync="deviceBindDialog"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <el-form>
            <el-form-item
              :label="
                $t('m.deviceManage.bindDevice.dialog.bindDialog.seriesNumber')
              "
            >
              <el-input
                type="textarea"
                :rows="2"
                v-model="serino"
                style="width:450px"
                :placeholder="
                  $t('m.deviceManage.bindDevice.dialog.bindDialog.placeholder')
                "
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="deviceBindDialog = false" class="dialog-footer-btn">
          {{ $t("m.deviceManage.bindDevice.dialog.bindDialog.cancel") }}
        </div>
        <div @click="bindDevice" class="dialog-footer-btn">
          {{ $t("m.deviceManage.bindDevice.dialog.bindDialog.confirm") }}
        </div>
      </div>
    </el-dialog>
    <!--------添加维保提醒弹框---------->
    <el-dialog
      :title="
        isAddRemain
          ? $t('m.deviceManage.bindDevice.addMaintenanceReminder')
          : $t('m.deviceManage.bindDevice.editMaintenanceReminder')
      "
      center
      :modal-append-to-body="false"
      :visible.sync="addRemainDialog"
    >
      <el-form ref="" label-width="80px">
        <el-row style="padding: 10px 30px;">
          <el-col :span="12">
            <el-form-item :label="$t('m.deviceManage.bindDevice.tableType')">
              <el-select
                v-model="remainForm.type"
                :placeholder="$t('m.table.select')"
              >
                <el-option
                  :key="1"
                  :label="$i18n.locale === 'en-US' ? 'Running' : '运行'"
                  :value="1"
                >
                </el-option>
                <el-option
                  :key="2"
                  :label="$i18n.locale === 'en-US' ? 'Roasting' : '烘焙'"
                  :value="2"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('m.deviceManage.bindDevice.timeHour')">
              <el-select
                v-model="remainForm.time"
                filterable
                allow-create
                default-first-option
                :placeholder="$t('m.table.select')"
              >
                <el-option :key="1" label="150" :value="150"> </el-option>
                <el-option :key="2" label="200" :value="200"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('m.deviceManage.bindDevice.content')">
          <el-input
            type="textarea"
            v-model="remainForm.content"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addRemainDialog = false">{{
          $t("m.deviceManage.bindDevice.dialog.bindDialog.cancel")
        }}</el-button>
        <el-button type="primary" @click="addRemain">{{
          $t("m.deviceManage.bindDevice.dialog.bindDialog.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <!--------添加维保弹框---------->
    <el-dialog
      :title="
        isAddMaintain
          ? $t('m.deviceManage.bindDevice.addMaintenanceHistory')
          : $t('m.deviceManage.bindDevice.editMaintenanceHistory')
      "
      center
      :modal-append-to-body="false"
      :visible.sync="addMaintainDialog"
    >
      <el-form ref="" label-width="80px">
        <!--<el-row style="padding: 10px 30px;">
          <el-col :span="12">
            <el-form-item label="类型">
              <el-select v-model="maintainForm.type">
                <el-option
                        :key="1"
                        label="小保养"
                        :value="1">
                </el-option>
                <el-option
                        :key="2"
                        label="大保养"
                        :value="2">
                </el-option>
              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="人员">
              <el-input v-model="maintainForm.worker" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>-->
        <el-form-item :label="$t('m.deviceManage.bindDevice.content')">
          <el-input
            type="textarea"
            v-model="maintainForm.content"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <!--<el-form-item label="解决方法">
          <el-input type="textarea" v-model="maintainForm.item" auto-complete="off"></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addMaintainDialog = false">{{
          $t("m.deviceManage.bindDevice.dialog.bindDialog.cancel")
        }}</el-button>
        <el-button type="primary" @click="addMaintain">{{
          $t("m.deviceManage.bindDevice.dialog.bindDialog.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <!--------曲线详情---------->
    <el-dialog
      :title="$t('m.deviceManage.bindDevice.operation.detail')"
      :visible.sync="reportDetailDialog"
    >
      <report-chart
        @finish="reportDetailLoadingFinish"
        :report-id="selectReportId"
        :key="reportKey"
      ></report-chart>
    </el-dialog>
  </div>
</template>

<script>
import mqtt from "mqtt";
//import report from '@/components/report/report'
import report from "@/components-online/curve/report";
import { getDwRorValue, getDwValue, getHJWValue, isValidDeviceInfo, 
  getRfValue, getPFWValue, getRFWValue,getHotValue, getGtValue, getLQValue} from '../../utils/utils';

export default {
  name: "onDeviceList",
  components: {
    "report-chart": report,
  },
  data() {
    return {
      bindDeviceList: [],
      activeBindId: 0,
      activeDeviceId: 0,
      activeSerino: "",
      selectDeviceNewMsgCount: 0,
      maintainLabel: "维保提醒",
      historyMsg: [],
      newMsgList: [],
      historyPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      newMsgPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      selectMsgIds: [],
      mqttInfo: {
        sdTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //豆温
        inWindTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //热风温
        outSideTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //环境温
        outWindTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //排风温
        fire: this.$t("m.deviceManage.bindDevice.notUpload"),
        wind: this.$t("m.deviceManage.bindDevice.notUpload"),
        speed: this.$t("m.deviceManage.bindDevice.notUpload"),
        cold: this.$t("m.deviceManage.bindDevice.notUpload"),
      },
      client: {},
      topic: "mqtt/device/",
      msg: "",
      mqttMsg: {},
      selectDevice: {
        device: { name: "", location: null, serino: "" },
        deviceType: { name },
        bind: { createtime: "" },
      },
      deviceReportList: [],
      deviceReportPage: {
        pageSize: 7,
        pageNum: 1,
        total: 0,
      },
      deviceTimeList: [],
      deviceRuntimePage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      deviceHbTimeList: [],
      deviceHbPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      deviceMaintainList: [],
      deviceMaintainPage: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      deviceRemainList: [],
      deviceRemainPage: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      deviceWarnList: [],
      deviceWarnPage: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      reportDetailDialog: false,
      selectReportId: 0,
      detailReport: {
        name: "",
        level: "",
        type: "",
        weight: 0,
        color: "",
        user: {},
        suitVo: {
          bean: {
            name: "",
          },
          lineVoList: [], //曲线数据
          height: 0,
          weight: 0,
        },
      }, //曲线详情
      reportKey: 0,
      loading: undefined,
      deviceBindDialog: false,
      serino: "",
      addMaintainDialog: false,
      maintainForm: {
        type: 1,
        worker: "",
        content: "",
        item: "",
        rules: [],
      },
      addRemainDialog: false,
      remainForm: {
        type: 1,
        time: "",
        content: "",
        id: "",
      },

      active1: 1,
      active2: 1,
      isAddRemain: true, // 是否是新增维保提醒
      isAddMaintain: true, // 是否是新增维保
      intervalId: null 
    };
  },

  mounted() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.loading = loading;
    this.getBindDevice();
    // this.getCheckBindDevice();
    loading.close();
  },
  beforeDestroy() {
    // this.client.end();
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null; // 重置为 null
    }
  },
  methods: {
    timeFormatter(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      var result = secondTime;
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime > 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      } else if (secondTime == 60) {
        return "01:00";
      } else {
        if (secondTime < 10) {
          return "00:0" + result;
        } else {
          return "00:" + result;
        }
      }
      result = parseInt(secondTime);
      if (result < 10) {
        result = "0" + result;
      }
      if (minuteTime > 0) {
        if (minuteTime < 10) {
          result = "0" + parseInt(minuteTime) + ":" + result;
        } else {
          result = parseInt(minuteTime) + ":" + result;
        }
      }
      if (hourTime > 0) {
        if (hourTime < 10) {
          result = "0" + parseInt(hourTime) + ":" + result;
        } else {
          result = parseInt(hourTime) + ":" + result;
        }
      }
      return result;
    },
    Utf8ArrayToStr(array) {
      var out, i, len, c;
      var char2, char3;

      out = "";
      len = array.length;
      i = 0;
      while (i < len) {
        c = array[i++];
        switch (c >> 4) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
            // 0xxxxxxx
            out += String.fromCharCode(c);
            break;
          case 12:
          case 13:
            // 110x xxxx   10xx xxxx
            char2 = array[i++];
            out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
            break;
          case 14:
            // 1110 xxxx  10xx xxxx  10xx xxxx
            char2 = array[i++];
            char3 = array[i++];
            out += String.fromCharCode(
              ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
            );
            break;
        }
      }
      return out;
    },
    deleteMsgClick(msg) {
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let ids = new Array();
          ids.push(msg.id);
          this.deleteMsg(ids);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
    deleteBatchClick() {
      if (this.selectMsgIds.length > 0) {
        this.$confirm(
          this.$t("m.alert.deleteConfirm"),
          this.$t("m.alert.reminder"),
          {
            confirmButtonText: this.$t("m.alert.confirm"),
            cancelButtonText: this.$t("m.alert.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            this.deleteMsg(this.selectMsgIds);
            this.selectMsgIds = [];
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("m.alert.canceled"),
            });
          });
      } else {
        this.$message.error(
          this.$i18n.locale === "en-US"
            ? "Select the message you want to delete"
            : "请选择要删除的消息"
        );
      }
    },
    deleteMsg(ids) {
      let params = new URLSearchParams();
      params.append("ids", ids);
      this.$http
        .post("/manage/message/update.do", params)
        .then(
          function(resp) {
            if (resp.data.success) {
              this.$message.success(this.$t("m.alert.deleteSuccess"));
              this.getHistoryMsg();
            } else {
              this.$message.error(this.$t("m.alert.deleteError"));
            }
          }.bind(this)
        )
        .catch((err) => err);
    },
    msgSelectChange(val) {
      console.info(val);
      this.selectMsgIds = [];
      if (val.length > 0) {
        for (let i in val) {
          this.selectMsgIds.push(val[i].id);
        }
      }
    },
    checkDevice(item) {
      let params = new URLSearchParams();
      this.activeSerino = item.device.serino;
      this.activeBindId = item.bind.id;
      this.activeDeviceId = item.device.id;
      this.selectDevice = item;
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.getCheckBindDevice();
      this.getDeviceInfo();
      this.intervalId = setInterval(() => {
        console.log('Interval running, ID:', this.intervalId);
        this.getDeviceInfo();
      }, 5000);
    },
    getCheckBindDevice() {
      this.getDeviceReportList();
      this.getDeviceTime();
      this.getDeviceHbTime();
      //this.getHistoryMsg()
      // this.getNewMsg()
      //this.newMsgCount()
      this.getDeviceRemain(this.activeDeviceId);
      this.getDeviceMaintain(this.activeDeviceId);
      this.getDeviceWarn(this.activeDeviceId);
    },
    newMsgCount() {
      this.$http
        .get(
          "/manage/message/countNewMessage.do?deviceId=" + this.activeDeviceId
        )
        .then(
          function(resp) {
            if (resp.data.success) {
              this.selectDeviceNewMsgCount = resp.data.data;
              // this.maintainLabel = this.$t('m.deviceIndex.MaintainNewMsg') + ':' + this.selectDeviceNewMsgCount
              this.maintainLabel = ":" + this.selectDeviceNewMsgCount;
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => err);
    },
    getHistoryMsg() {
      let params = new URLSearchParams();
      params.append("deviceId", this.activeDeviceId);
      params.append("pageNum", this.historyPage.pageNum);
      params.append("pageSize", this.historyPage.pageSize);
      this.$http
        .post("/manage/message/getHistoryMsg.do", params)
        .then(
          function(resp) {
            if (resp.data.success) {
              this.historyMsg = resp.data.data.list;
              this.historyPage.total = resp.data.data.total;
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => err);
    },
    getNewMsg() {
      let params = new URLSearchParams();
      params.append("deviceId", this.activeDeviceId);
      params.append("pageNum", this.newMsgPage.pageNum);
      params.append("pageSize", this.newMsgPage.pageSize);
      this.$http
        .post("/manage/message/getNewMsg.do", params)
        .then(
          function(resp) {
            if (resp.data.success) {
              this.newMsgList = resp.data.data.list;
              this.newMsgPage.total = resp.data.data.total;
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => err);
    },
    getBindDevice() {
      let params = new URLSearchParams();
      params.append("pageSize", 20);
      params.append("pageNum", 1);
      this.$http
        .get("/manage/device/findBinds.do", params)
        .then(
          function(resp) {
            if (resp.data.success) {
              this.bindDeviceList = resp.data.data;
              if (this.bindDeviceList.length > 0) {
                this.checkDevice(this.bindDeviceList[0])
              }
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => err);
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      //.replace(/年|月/g, "-").replace(/日/g, " ")
      return this.$moment(date).format("YYYY-MM-DD");
    },
    dateFormat1(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      //.replace(/年|月/g, "-").replace(/日/g, " ")
      return this.$moment(date).format("YYYY-MM-DD hh:mm");
    },
    getDeviceReportList() {
      this.$http
        .get("/manage/report/getOnlyListByDevice.do", {
          params: {
            pageSize: this.deviceReportPage.pageSize,
            pageNum: this.deviceReportPage.pageNum,
            serino: this.selectDevice.device.serino,
          },
        })
        .then(
          function(resp) {
            this.deviceReportList = resp.data.data.list;
            this.deviceReportPage.total = resp.data.data.total;
          }.bind(this)
        )
        .catch((err) => err);
    },
    deviceReportPageChange(val) {
      this.deviceReportPage.pageNum = val;
      this.getDeviceReportList();
    },
    deviceReportPageSizeChange(val) {
      this.deviceReportPage.pageSize = val;
      this.getDeviceReportList();
    },
    getDeviceTime() {
      this.$http
        .get("/manage/deviceLog/list.do", {
          params: {
            deviceId: this.selectDevice.device.id,
            type: 1,
            pageNum: this.deviceRuntimePage.pageNum,
            pageSize: this.deviceRuntimePage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceRuntimePage.total = resp.data.data.total;
            this.deviceTimeList = resp.data.data.list;
            /*for (let len in this.deviceTimeList) {
              this.deviceTimeList[len].time = this.deviceTimeList[len].time+"min"
            }*/
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            let totalTime = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] =
              (this.$i18n.locale === "en-US" ? "Total: " : "总和：") +
              this.timeFormatter(totalTime);
          } else {
            sums[index] = "N/A";
          }
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    deviceTimePageChange(val) {
      this.deviceRuntimePage.pageNum = val;
      this.getDeviceTime();
    },
    deviceTimePageSizeChange(val) {
      this.deviceRuntimePage.pageSize = val;
      this.getDeviceTime();
    },
    deviceHbTimePageChange(val) {
      this.deviceHbPage.pageNum = val;
      this.getDeviceHbTime();
    },
    deviceHbTimePageSizeChange(val) {
      this.deviceHbPage.pageSize = val;
      this.getDeviceHbTime();
    },
    getDeviceHbTime() {
      this.$http
        .get("/manage/deviceLog/list.do", {
          params: {
            deviceId: this.selectDevice.device.id,
            type: 2,
            pageNum: this.deviceHbPage.pageNum,
            pageSize: this.deviceHbPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceHbPage.total = resp.data.data.total;
            this.deviceHbTimeList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    deviceMaintainPageChange(val) {
      this.deviceMaintainPage.pageNum = val;
      this.getDeviceMaintain(this.activeDeviceId);
    },
    deviceMaintainPageSizeChange(val) {
      this.deviceMaintainPage.pageSize = val;
      this.getDeviceMaintain(this.activeDeviceId);
    },
    getDeviceMaintain(deviceId) {
      this.$http
        .get("/manage/deviceMaintain/list.do", {
          params: {
            deviceId: deviceId,
            pageNum: this.deviceMaintainPage.pageNum,
            pageSize: this.deviceMaintainPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceMaintainPage.total = resp.data.data.total;
            this.deviceMaintainList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    deviceRemainPageChange(val) {
      this.deviceRemainPage.pageNum = val;
      this.getDeviceRemain(this.activeDeviceId);
    },
    deviceRemainPageSizeChange(val) {
      this.deviceRemainPage.pageSize = val;
      this.getDeviceRemain(this.activeDeviceId);
    },
    getDeviceRemain(deviceId) {
      this.$http
        .get("/manage/deviceRemain/list.do", {
          params: {
            deviceId: deviceId,
            pageNum: this.deviceRemainPage.pageNum,
            pageSize: this.deviceRemainPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceRemainPage.total = resp.data.data.total;
            this.deviceRemainList = resp.data.data.list;
            for (let index in this.deviceRemainList) {
              var typeText = "";
              if (this.deviceRemainList[index].type == 1) {
                typeText =
                  "每运行" + this.deviceRemainList[index].time + "小时";
              } else if (this.deviceRemainList[index].type == 2) {
                typeText =
                  "每烘焙" + this.deviceRemainList[index].time + "小时";
              }
              this.deviceRemainList[index].typeNumber = this.deviceRemainList[
                index
              ].type;
              this.deviceRemainList[index].type = typeText;
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    deviceWarnPageChange(val) {
      this.deviceWarnPage.pageNum = val;
      this.getDeviceWarn(this.activeDeviceId);
    },
    deviceWarnPageSizeChange(val) {
      this.deviceWarnPage.pageSize = val;
      this.getDeviceWarn(this.activeDeviceId);
    },
    getDeviceWarn(deviceId) {
      this.$http
        .get("/manage/deviceWarn/list.do", {
          params: {
            deviceId: deviceId,
            pageNum: this.deviceWarnPage.pageNum,
            pageSize: this.deviceWarnPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.deviceWarnPage.total = resp.data.data.total;
            this.deviceWarnList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    reportDetailLoadingFinish() {
      //this.loading.close()
    },
    reportDetailClick(report) {
      //console.info(report)
      /*this.$http.get("/manage/report/getAReportById.do", {
              params: {
                  reportId: report.report.id,
              }
          }).then(function (resp) {
              this.detailReport = resp.data.data
          }.bind(this)).catch(err => {
              console.info(err)
          }) 与report.vue重复调用*/
      /*setTimeout(() => {
              loading.close();
          }, 2000);*/
      this.reportDetailDialog = true;
      this.selectReportId = report.report.id;
      this.reportKey = this.selectReportId;
    },
    bindDevice() {
      if (this.serino.trim().length <= 0) {
        this.$message.error(
          this.$t("m.deviceManage.bindDevice.dialog.bindDialog.placeholder")
        );
      } else {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.loading = loading;
        let params = new URLSearchParams();
        params.append("ori", this.serino);
        this.$http
          .post("/manage/device/bindPC.do", params)
          .then(
            function(resp) {
              if (resp.data.success) {
                this.getBindDevice();
                this.getCheckBindDevice();
                this.$message.success(this.$t("m.alert.updateSuccess"));
                this.deviceBindDialog = false;
              } else {
                this.$message.error(this.$t("m.alert.updateError"));
              }
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
        loading.close();
      }
    },
    deviceUnbind() {
      this.$confirm(this.$t("m.alert.tip1"), this.$t("m.alert.reminder"), {
        confirmButtonText: this.$t("m.alert.confirm"),
        cancelButtonText: this.$t("m.alert.cancel"),
        type: "warning",
      })
        .then(() => {
          let bindId = this.activeBindId;
          var params = new URLSearchParams();
          params.append("bindId", bindId);
          this.$http
            .post("/manage/device/unbind.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.updateSuccess"));
                  this.getBindDevice();
                  this.getCheckBindDevice();
                } else {
                  this.$message.error(this.$t("m.alert.updateError"));
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
    addMaintain() {
      //todo  添加表单验证
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      let params = new URLSearchParams();
      params.append("deviceid", this.activeDeviceId);
      params.append("type", 1);
      /*params.append('item', this.maintainForm.item)
          params.append('worker', this.maintainForm.worker)*/
      params.append("content", this.maintainForm.content);
      this.maintainForm.id && params.append("id", this.maintainForm.id);

      if (this.isAddMaintain) {
        this.$http
          .post("/manage/deviceMaintain/add.do", params)
          .then(
            function(resp) {
              if (resp.data.success) {
                this.$message.success(this.$t("m.alert.addSuccess"));
                this.getCheckBindDevice();
                this.addMaintainDialog = false;
              } else {
                this.$message.error(this.$t("m.alert.addError"));
              }
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      } else {
        this.$http
          .post("/manage/deviceMaintain/update.do", params)
          .then(
            function(resp) {
              if (resp.data.success) {
                this.$message.success(this.$t("m.alert.changeSuccess"));
                this.getCheckBindDevice();
                this.addMaintainDialog = false;
              } else {
                this.$message.error(this.$t("m.alert.changeError"));
              }
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      }

      loading.close();
    },

    // 维保编辑
    deviceMaintainEdit(data) {
      if (!data) {
        this.maintainForm.content = "";
        this.maintainForm.id = "";
        this.isAddMaintain = true;
      } else {
        this.maintainForm.content = data.content;
        this.maintainForm.id = data.id;
        this.isAddMaintain = false;
      }
      //console.log(data);
      this.addMaintainDialog = true;
    },
    // 维保删除
    deviceMaintainDelete(data) {
      //let timeStr = this.$moment(data.createtime).format("YYYY-MM-DD");
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let params = new URLSearchParams();
          params.append("id", data.id);
          params.append("delstatus", 1);
          params.append("type", 1);
          this.$http
            .post("/manage/deviceMaintain/update.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.getCheckBindDevice();
                } else {
                  this.$message.error(this.$t("m.alert.deleteError"));
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.cancelDelete"),
          });
        });
    },

    addRemain() {
      //todo  添加表单验证
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      let params = new URLSearchParams();
      params.append("deviceid", this.activeDeviceId);
      params.append("type", this.remainForm.type);
      params.append("time", this.remainForm.time);
      params.append("content", this.remainForm.content);
      this.remainForm.id && params.append("id", this.remainForm.id);
      if (this.isAddRemain) {
        this.$http
          .post("/manage/deviceRemain/add.do", params)
          .then(
            function(resp) {
              if (resp.data.success) {
                this.isAddRemain
                  ? this.$message.success(this.$t("m.alert.addSuccess"))
                  : this.$message.success(this.$t("m.alert.changeSuccess"));
                this.getCheckBindDevice();
                this.addRemainDialog = false;
              } else {
                this.isAddRemain
                  ? this.$message.error(this.$t("m.alert.addError"))
                  : this.$message.error(this.$t("m.alert.changeError"));
              }
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      } else {
        console.log(this.remainForm.content);
        this.$http
          .post("/manage/deviceRemain/update.do", params)
          .then(
            function(resp) {
              if (resp.data.success) {
                this.isAddRemain
                  ? this.$message.success(this.$t("m.alert.addSuccess"))
                  : this.$message.success(this.$t("m.alert.changeSuccess"));
                this.getCheckBindDevice();
                this.addRemainDialog = false;
              } else {
                this.$message.error(resp.data.msg);
              }
            }.bind(this)
          )
          .catch((err) => {
            console.info(err);
          });
      }

      loading.close();
    },
    // 维保编辑
    deviceRemainEdit(data) {
      if (!data) {
        this.remainForm.type = "";
        this.remainForm.time = "";
        this.remainForm.content = "";
        this.remainForm.id = "";
        this.isAddRemain = true;
      } else {
        this.remainForm.type = data.typeNumber;
        this.remainForm.time = data.time;
        this.remainForm.content = data.content;
        this.remainForm.id = data.id;
        this.isAddRemain = false;
      }
      //console.log(data);
      this.addRemainDialog = true;
    },
    // 维保删除
    deviceRemainDelete(data) {
      //let timeStr = this.$moment(data.createtime).format("YYYY-MM-DD");
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let params = new URLSearchParams();
          params.append("id", data.id);
          params.append("delstatus", 1);
          this.$http
            .post("/manage/deviceRemain/update.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.getCheckBindDevice();
                } else {
                  this.$message.error(this.$t("m.alert.deleteError"));
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.cancelDelete"),
          });
        });
    },
    // mqttMsg(){
    //     let topic='mqtt/device/'+this.activeSerino
    //     console.info('开始连接'+this.activeSerino)
    //     client.on('connect',(e)=>{
    //         console.log("连接成功！！！"+e.toString())
    //         // client.subscribe(topic, (error) => {
    //         //     if (!error) {
    //         //         console.log('订阅成功')
    //         //     } else {
    //         //         console.log('订阅失败')
    //         //     }
    //         // })
    //         client.subscribe(topic)
    //     })
    //     client.on('message', (topic, message) => {
    //         console.log('收到来自', topic, '的消息', message.toString())
    //         this.$message.success('收到mqtt消息'+message)
    //         this.msg = message.toString()
    //     })
    // }
    getDeviceInfo() {
      this.$http.get(`/manage/metrics/get/${this.activeSerino}`).then(res => {
        if (res.data) {
          if (res.data.v1) {
            let item = res.data.v1.indicatorVoList;
            item.forEach(indicator => {
              switch (indicator.type) {
                case 1:
                  this.mqttInfo.sdTemperature = indicator?.value; // 豆温
                  break;
                case 2:
                  this.mqttInfo.inWindTemperature = indicator?.value; // 热风温
                  break;
                case 3:
                  this.mqttInfo.outSideTemperature = indicator?.value; // 环境温
                  break;
                case 4:
                  this.mqttInfo.outWindTemperature = indicator?.value; // 排风温
                  break;
                case 5:
                  this.mqttInfo.fire = indicator?.value; // 火力
                  break;
                case 6:
                  this.mqttInfo.wind = indicator?.value; // 风速
                  break;
                case 7:
                  this.mqttInfo.speed = indicator?.value; // 滚筒转速
                  break;
                case 8:
                  this.mqttInfo.cold = indicator?.value; // 冷却
                  break;
                default:
                  console.warn(`Unknown type: ${indicator.type}`);
              }
            });
          } else if (res.data.v2) {
            let item = JSON.parse(res.data.v2.content)
            this.mqttInfo = {
              sdTemperature: getDwValue(item), //豆温
              inWindTemperature: getRFWValue(item), //热风温
              outSideTemperature: getHJWValue(item), //环境温
              outWindTemperature: getPFWValue(item), //排风温
              fire: getHotValue(item),
              wind: getRfValue(item),
              speed: getGtValue(item),
              cold: getLQValue(item)
            }
        } else {
          this.mqttInfo = {
            sdTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //豆温
          inWindTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //热风温
          outSideTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //环境温
          outWindTemperature: this.$t("m.deviceManage.bindDevice.notUpload"), //排风温
          fire: this.$t("m.deviceManage.bindDevice.notUpload"),
          wind: this.$t("m.deviceManage.bindDevice.notUpload"),
          speed: this.$t("m.deviceManage.bindDevice.notUpload"),
          cold: this.$t("m.deviceManage.bindDevice.notUpload"),
        };
        }
      }
        }).catch(err => {
        console.error(err);
      });
    },
  },
};
</script>
